import api from '@synergycms_core/utils/api';
import { apiGetter } from '@synergycms_core/utils/api';
import actions from '../actions';

import { Map, fromJS } from 'immutable';
import storage from '@synergycms_core/utils/storage';
import { forEach, reduce, equals } from 'ramda';
import ParamsParser from '@synergycms_core/utils/paramsParser';
import { keyIn } from '@synergycms_core/utils/utils';
import moment from 'moment';
import { getLoyaltyTier } from './loyaltyUtils';
import loggerGetter from '@synergycms_core/utils/logger';




export const STAR_TRAVELER_CODE = "startraveler";
export const STAR_TRAVELER_MAX_ROOMS_POINTS = 2;
export const FIDELTOUR_CODE = "fideltour";

export const refreshLoyaltyReservation = ({dispatch, getState}) => {
  const store = getState();
  const user = store.getIn(['customer', 'loyalty','user','user_id'], null) && store.getIn(['customer', 'loyalty','user'], null)
  const reservation  = store.getIn(['customer', 'reservation']);

  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotel = hotelId && store.getIn(['customer', 'loyalty', 'descriptives', hotelId, 'loyalty'], null);
  const loyalty = (hotel?.size && hotel);
  const loyaltyType = loyalty && loyalty.get("code");
  const loyaltyTier = loyalty && loyalty.get("tier");

  const roomRatesSelected = store.getIn(['customer', 'reservation_request']);
  const loyaltyRoomsAvail = store.getIn([
    'avail',
    hotelId,
    store.getIn(['hotels', hotelId, 'params', 'loyalty_query_params']),
    'response'
  ],false);

  let loyaltySelected = !!loyaltyRoomsAvail && roomRatesSelected.get('loyalty', false);

  let loyaltyConfig = null;

  if(user && loyaltyType) {
    dispatch(actions.customer.availTypeSelected.set("loyalty"));
  }

  if (reservation?.size && user) {
    loyaltyConfig =  Map({
      email : user.get("email"),
      user_id : user.get("user_id"),
      token: user.get("token"),
      selected : user.getIn(["tier","current"])
    });
  }

  if(loyaltySelected && !user) {
    loyaltyConfig = Map({
      selected : loyaltyTier
    });
  }

  const reservationLoyaltyConfig = loyaltyType === STAR_TRAVELER_CODE ? loyaltyConfig : loyaltyConfig?.get('selected') || null;

  const isNotFinallyConfirmed = reservation && reservation.get('status', false) !== 'confirmed';

  //dispatch(actions.customer.loyalty.setParams());

  let currentStep = getState().getIn(['customer', 'step', 'current_step','code'], null);
  let group = false;
  if(currentStep === 'multiHotelAvail') {
    group = getState().get('group')
  }
  if(reservation && reservation.size && isNotFinallyConfirmed) {
    let value = Map({
      tracking_id: reservation.get('tracking_id'),
      loyalty : loyaltyConfig
    });

    if (reservation.getIn(['promotion', 'code'], null)) { //promotion code
      value = value.set('promotion_code', reservation.getIn(['promotion', 'code']));
    }
    if (reservation.getIn(['gift_voucher', 'code'], null)) { // gift voucher
      value = value.set('gift_voucher', reservation.getIn(['gift_voucher', 'code']));
    }
    
    const availActions = actions.avail;
    const availPromise = dispatch(availActions.getAvailAsync(group));
    return dispatch(actions.customer.reservation.postAsync(value, false)).then(() => {
      dispatch(actions.customer.params.updateParams(value.delete("tracking_id")));
      dispatch(actions.customer.reservationRequest.set(Map({loyalty : reservationLoyaltyConfig})));
      return availPromise.then(()=> dispatch(availActions.getAvailParsed())).then(()=>{
        return dispatch(actions.customer.reservationRequest.refreshBlocks(value)).then(() => {

          // ------ LOGGER PRECIOS ------
          const stateAfter = getState();

          const reservationBefore = reservation;
          const requestAfter  = stateAfter.getIn(['customer','reservation_request']);

          const priceBefore = reservationBefore?.get('total_price');
          const priceAfter  = requestAfter?.get('total_price');
          const priceTaxBefore = reservationBefore?.get('total_price_tax');
          const priceTaxAfter  = requestAfter?.get('total_price_tax');

          if (priceBefore !== priceAfter || priceTaxBefore !== priceTaxAfter) {
            const logger = loggerGetter();

            logger.addLine(
              'LOYALTY_PRICE_MISMATCH',
              JSON.stringify({
                price_before: priceBefore,
                price_after: priceAfter,
                price_tax_before: priceTaxBefore,
                price_tax_after: priceTaxAfter,
                promotion_code: reservation.getIn(['promotion','code'], null),
                gift_voucher: reservation.getIn(['gift_voucher','code'], null),
                reservation_before: reservationBefore && reservationBefore.toJS ? reservationBefore.toJS() : reservationBefore,
                request_after: requestAfter && requestAfter.toJS ? requestAfter.toJS() : requestAfter,
              }, null, 2)
            ).sendMail();
          }
          // ------------------------------

          return dispatch(actions.router.update());
        });
      });
    });
  } else if(getState().getIn(["customer","params", "params"])){
    dispatch(actions.availCalendar.refresh());
    return dispatch(actions.avail.getAvailAsync(group)).then(() => {
      dispatch(actions.avail.getAvailParsed());
      dispatch(actions.customer.reservationRequest.initialize());
      return;
    });
  } else {
    return Promise.resolve();
  }

}


export default {
  GET: (user) => (dispatch,getState)=> {
    if(!user || (user.expiration_time && moment(user.expiration_time) < moment())){
      user = null;
    }
    return user || null;
  },
  UPDATE : (loyalty) => {
    return loyalty;
  },
  SET_LOYALTY_TIER : (loyalty) => (dispatch, getState) => {
    let tier = getLoyaltyTier(getState(), loyalty)
    getState().get(["params","params",loyalty])
    if (tier !== getState().get(["params","params", "loyalty"])) {
      dispatch(actions.customer.params.updateParams(Map({ loyalty: tier })));
    }
  },
  GET_USER : () => (dispatch, getState) => {

    const store = getState();
    const hotelId = store.getIn(["customer", "current_hotel"]);
    const loyalty = hotelId && store.getIn(['hotels', hotelId, 'loyalty'], null);
    const loyaltyUser = store.getIn(['customer', 'loyalty', 'user'], null);
    const reservation = hotelId && store.getIn(['customer', 'reservation'], false);

    if(hotelId && loyalty && loyaltyUser && !reservation.size) {

      return api.get('management/loyalty/'+loyalty.get('id')+'/resources/contact', {id: loyaltyUser.get('user_id')}, hotelId).then((response) => {

        if (response == null) {
          throw new Error('Error en la petición');
        }

        const { success, ...data } = response;

        if (!success) {
          throw new Error(data.message);
        }
        if(data.id){
          data.user_id = data.id;
        }
        //const customer = set(hotelId, data, store.getIn(['customer', 'loyalty','user']).toJS());
        storage.setLocal("login_user", data);
        dispatch(actions.customer.loyalty.update(data));
      });
    }else {
      return Promise.resolve();
    }

  },
  GET_USER_ASYNC: (loginContext, userToken, remember, userData) => {
    return (dispatch, getState) => {
      return api.get(
        `loyalty/user?q=${loginContext.key}:${loginContext.value}`,
        null,
        null,
        [{'Authorization': `Basic ${userToken}`}])
      .then(response => {

        if(response.success !== undefined && response.success === false){
          storage.unset('login_user');
          storage.unsetLocal('login_user');
          return false;
        }

        let loyaltyUser = {}
        if(remember){
          loyaltyUser = {...storage.getLocal('login_user'), ...response};
          storage.setLocal('login_user', loyaltyUser);

        } else {
          loyaltyUser = {...storage.get('login_user'), ...response};
          storage.set('login_user', loyaltyUser);
        }

        return loyaltyUser;

      }).catch(() => {
        storage.unsetLocal('login_user');
        storage.unset('login_user');
        return false;
      });
    }
  },
  SET_PARAMS : () => (dispatch, getState) => {

    const store = getState();
    const hotelId = store.getIn(["customer", "current_hotel"]);
    const loyaltyUser = hotelId && store.getIn(['customer', 'loyalty','user', hotelId], null);

    dispatch(actions.customer.params.updateParams(Map({ loyalty: loyaltyUser && loyaltyUser.get('user_id')})));
  },
  GET_DESCRIPTIVE_ASYNC: (group = false) => {
    return (dispatch, getState) => {
      const store = getState();
      const queryId = group || store.getIn(['customer', 'params', 'params', 'hotelId']);
      if (queryId) {
          return api.get({
            params:group ?{q:"group:"+queryId} : {q:"hotel_id:"+queryId},
            path:`loyalty/descriptive_info`,
            fullFiled: ()=> {
              return getState().getIn(["loyalty", "hotels", queryId],null);
            },
            store: ({ store, request }) => {

              if(!store[queryId]) {
                store[queryId] = request();
              }
              return store[queryId];
            }
          }).then(loyaltyHotelDescriptive => {


            if (loyaltyHotelDescriptive.success !== false) {

              let tiers = loyaltyHotelDescriptive.tiers && reduce((map, tier)=> {
                tier.advantages = [];
                map[tier.id] = tier;
                return map;
              },{}, loyaltyHotelDescriptive.tiers);

              loyaltyHotelDescriptive.advantages && forEach((advantage)=> {
                const tiersAdvantages = advantage.extended.tier_advantages;
                forEach((tierAdvantage)=> {
                  if(tiers[tierAdvantage.tier_id]){
                    tiers[tierAdvantage.tier_id].advantages.push(advantage);
                  }
                }, tiersAdvantages);
              },loyaltyHotelDescriptive.advantages);

              loyaltyHotelDescriptive.loyalty.tier = loyaltyHotelDescriptive.tiers[0]?.code;
              dispatch(actions.availQuery.setMultiAvailKeys(!!loyaltyHotelDescriptive?.loyalty?.code));

              const loyalty = fromJS((loyaltyHotelDescriptive?.loyalty?.code && getState().getIn(['customer', 'corporate', 'tipo_perfil'], false) !== '1') ? loyaltyHotelDescriptive : null);

              dispatch(actions.customer.loyalty.setLoyaltyTier(loyalty));

              return fromJS({[queryId]:loyalty});
            }
          });
      } else {
        return Promise.resolve();
      }
    }
  },
  LOYALTY_ASYNC : ()=>  {
    return (dispatch, getState) => {
      const {
        loyalty   : loyaltyActions
        } = actions.customer;
      const hotelsActions = actions.hotels;
      const store = getState();
      const hotelId = store.getIn(['customer', 'current_hotel']);
      if(store.getIn(['customer', 'corporate', 'tipo_perfil'], false) === '1'){
          return Promise.resolve().then(()=>{
            return Map();
          });
      }
      return Promise.all([
        hotelId && dispatch(hotelsActions.getAsync()).then((result) => {
          const store = getState();
          let loyalty = store.getIn(['hotels', hotelId, 'loyalty', 'code'], false);
          return loyalty && dispatch(loyaltyActions.getDescriptiveAsync());
        }),
        dispatch(actions.groupInfo.getAsync())
      ]).then(() => {
        const store = getState();
        const hotel = hotelId && store.getIn(['customer', 'loyalty', 'descriptives', hotelId, 'loyalty'], null);
        //const group = store.getIn(['groupInfo', 'loyalty'], null);
        let loyalty = (hotel?.size && hotel);
        const loyaltyType = loyalty && loyalty.get("code");
        let loyaltyInfo = hotelId && store.getIn(['customer', 'loyalty', 'descriptives', hotelId], Map())
        const groupName = store.getIn(['group'], null);

        switch (loyaltyType) {
          case STAR_TRAVELER_CODE :
            if (store.getIn(['customer', 'web_type'], false) === "WI" && groupName !== 'eurostarshotels') {
              //actions.customer.loyalty.get(null);
              loyaltyInfo = Map();
            }
            break;
          case FIDELTOUR_CODE :
            /*const ipCountry = store.getIn(['customer','country_ip'], false) === "ES";
            if (!ipCountry) {
              actions.loyalty.get(null);
              return null;
            }*/
            break;
          default:
            loyaltyInfo = Map();
        }

        dispatch(actions.customer.availTypeSelected.set(!!loyaltyInfo?.size ? "loyalty" : "standard"));
        dispatch(actions.customer.loyalty.setLoyaltyTier(loyaltyInfo));
        return loyaltyInfo;
      });
    };
  },
  REGISTER : (inputList) => (dispatch, getState) => {

    const store = getState();
    const hotelId = store.getIn(['customer', 'current_hotel']);
    const loyalty = hotelId && store.getIn(['hotels', hotelId, 'loyalty'], null);

    if(hotelId && loyalty) {

      const body = Object.values(inputList).reduce((acc, { model, value } = {}) => {
        if(!model || !value) return acc;
        if(model === "required_policies") acc['accept_conditions'] = value;
        else acc[model] = value;
        return acc;
      }, {});

      body.subscribed = typeof inputList.subscribed === 'boolean' ? inputList.subscribed : inputList.subscribed.value;
      body.phone2 = body.phone;
      body.phone = '+' + body.country.get('phone_prefix') + body.phone;
      body.country = body.country.get('alpha2');
      body.source = 8;
      delete body.repeatPassword;


      return api.post('management/loyalty/'+loyalty.get('id')+'/resources/register', body, hotelId).then((response) => {

        if (response == null) {
          throw new Error('Error en la petición');
        }

        const { success, ...data } = response;

        if (!success) {
          throw new Error(data.message);
        }


        if(response.user) {
          const userData = response.user;

          storage.setLocal("login_user", userData);
          dispatch(actions.customer.loyalty.update(userData));
          return refreshLoyaltyReservation({dispatch, getState});
        }

      });

    }
    return Promise.reject();
  },
  LOGIN : (inputList) => (dispatch, getState) => {

    const store = getState();
    const hotelId = store.getIn(['customer', 'current_hotel']);
    const loyalty = hotelId && store.getIn(['hotels', hotelId, 'loyalty'], null);

    if(!!loyalty) {

      const body = Object.values(inputList).reduce((acc, { model, value }) => {
        acc[model] = value;
        return acc;
      }, {});

      return api.post('management/loyalty/'+loyalty.get('id')+'/resources/login', body, hotelId).then((response) => {

        if (response == null) {
          throw new Error('Error en la petición');
        }

        const { success, ...data } = response;

        if (!success) {
          throw new Error(data.message);
        }
        if(data.id){
          data.user_id = data.id;
        }
        //const customer = set(hotelId, data, store.getIn(['customer', 'loyalty', 'user']) || Map().toJS());
        storage.setLocal("login_user", data);
        dispatch(actions.customer.loyalty.update(data));
        return refreshLoyaltyReservation({dispatch, getState});
      });
    }
  },
  LOGOUT : () => (dispatch, getState) => {

    //Delete BlockPoints
    //TODO -> Vigilar con los cambios de allow_loyalty_point_redemption para detectar si eliminar o no
    const store = getState();
    const allowLoyaltyPoint = store.getIn(['customer', 'reservation', 'customer', 'allow_loyalty_point_redemption'], false);
    if(allowLoyaltyPoint){
      dispatch(actions.customer.loyalty.deleteBlockPointsAsync());
    }

    storage.setLocal("login_user", null);
    storage.set("login_user", null);
    dispatch(actions.customer.loyalty.update(null));

    let tier = getLoyaltyTier(getState(), null,true)
    if (tier) {
      dispatch(actions.customer.params.updateParams(Map({ loyalty: tier })));
    }

    return refreshLoyaltyReservation({dispatch, getState});
  },
  SAVE_SEARCH : (oldUrl = false) => (dispatch, getState) => {
    const store = getState();
    const groupCode = store.get('group', false);
    const userLoyalty = store.getIn(['customer', 'loyalty', 'user'], false);
    const userEmail = userLoyalty && userLoyalty.get('email',false);
    const userToken = userLoyalty && userLoyalty.get('token',false);
    const loyaltyType = store.getIn(["customer", "loyalty", "data", "loyalty","code"],false)

    if(loyaltyType === STAR_TRAVELER_CODE && userLoyalty && userEmail && userToken){

      const newUrl = storage.getLocal('last_valid_route');

      //Si tenemos oldUrl comprobaremos que la newUrl es distinta a oldUrl, si oldUrl es false realizamos peticion sin comprobacion
      if(oldUrl){
        const keyFilter = keyIn('hotelCode', 'hotelCodes', 'city_id', 'start', 'end', 'occups');

        //Convertimos la url en un objeto y le pasamos un filtro de propiedades principales para eliminar las que no nos interesas
        const newParams = ParamsParser.urlToParams('?'+newUrl.search).filter(keyFilter);
        const oldParams = ParamsParser.urlToParams('?'+oldUrl.search).filter(keyFilter);

        if(!equals(newParams,oldParams)){
          sendLoyaltySearch(newUrl,userEmail,userToken,groupCode);
        }

      }else{
        sendLoyaltySearch(newUrl,userEmail,userToken,groupCode);
      }
    }
  },
  REFRESH_RESERVATION : () => (dispatch, getState) => {
    return refreshLoyaltyReservation({dispatch, getState});
  },
  GET_USER_POINTS_ASYNC :  () => (dispatch, getState) => {
    const store = getState();
    const loyaltyUser = store.getIn(['customer', 'loyalty','user']);

    if (loyaltyUser.get("user_id")) {
      return Promise.resolve({ points : { total : 150 }});
    }

    /*return api.get('management/user_points', { id: loyaltyUser.get('user_id') }).then((response) => {
      return response;
    });*/
  },
  REFRESH_BLOCK_POINTS_ASYNC : () => (dispatch, getState) => {
    const store = getState();

    const loyaltyUser = store.getIn(['customer', 'loyalty', 'user']);
    var loyaltyApi = apiGetter("hotels", "loyalty");
    loyaltyApi.setAuthHeader(loyaltyUser.get("user_id"),loyaltyUser.get("token"));

    const trackingId = store.getIn(['customer', 'reservation', 'tracking_id'], null)

    if (loyaltyUser.get("user_id") && trackingId) {
      return loyaltyApi.get(`loyalty/block_points/${trackingId}`, null, store.getIn(["customer", "current_hotel"]));
    }

    return Promise.reject();
  },
  SET_BLOCK_POINTS_ASYNC :  () => (dispatch, getState) => {
    const store = getState();
    const trackingId = store.getIn(['customer', 'reservation', 'tracking_id'], null)
    const loyaltyUser = store.getIn(['customer', 'loyalty', 'user']);

    var loyaltyApi = apiGetter("hotels", "loyalty");
    loyaltyApi.setAuthHeader(loyaltyUser.get("user_id"), loyaltyUser.get("token"));
    return loyaltyApi.patch('loyalty/block_points',{tracking_id :trackingId},store.getIn(["customer", "current_hotel"])).then((response) => {
      return response;
    });
  },
  DELETE_BLOCK_POINTS_ASYNC :  (additionalInfo = false) => (dispatch, getState) => {
    const store = getState();
    const loyaltyUser = store.getIn(['customer', 'loyalty','user']);

    const loyaltyApi = apiGetter("hotels", "loyalty");
    loyaltyApi.setAuthHeader(loyaltyUser.get("user_id"), loyaltyUser.get("token"));
    const url = !additionalInfo ? 'loyalty/block_points' : 'loyalty/block_points?'+additionalInfo+'=true';
    return loyaltyApi.delete(url, store.getIn(["customer", "current_hotel"]));

  },
  SET_BOOKING_TMS_ASYNC :  () => (dispatch, getState) => {
    const store = getState();

    const trackingId = store.getIn(['customer', 'reservation', 'tracking_id'], null)
    const loyaltyUser = store.getIn(['customer', 'loyalty', 'user']);


    if(loyaltyUser.get("user_id") && trackingId) {
      const loyaltyApi = apiGetter("hotels", "loyalty");
      loyaltyApi.setAuthHeader(loyaltyUser.get("user_id"),loyaltyUser.get("token"));
      return loyaltyApi.post(`loyalty/send_booking_tms`, {tracking_id :trackingId}, store.getIn(["customer", "current_hotel"])).then((response) => {
        if (response.success === false) {
          return Promise.reject(response);
        }
        return response;
      });
    }
    return Promise.resolve();
  },
  DELETE_BOOKING_TMS_ASYNC :  () => (dispatch, getState) => {
    const store = getState();
    const loyaltyUser = store.getIn(['customer', 'loyalty','user']);
    const trackingId = store.getIn(['customer', 'reservation', 'tracking_id'], null)


    if(loyaltyUser.get("user_id") && trackingId) {
      const loyaltyApi = apiGetter("hotels", "loyalty");
      loyaltyApi.setAuthHeader(loyaltyUser.get("user_id"), loyaltyUser.get("token"));
      return loyaltyApi.delete(`loyalty/send_booking_tms/${trackingId}`, store.getIn(["customer", "current_hotel"]));
    }

  },
};

function sendLoyaltySearch(newUrl,userEmail,userToken,groupCode) {
  const body = {
    url : window.location.origin + newUrl.pathname + '?' + newUrl.search,
    group : groupCode
  };

  const extraHeaders = [{ Authorization: 'Basic ' + btoa(userEmail + ':' + userToken) }];
  return api.post('login/user/save_search_async', body, null, extraHeaders);
}


/*
http://dev.synergy.app/api/hotels/153/loyalty/send_booking_tms/{tracking_id}
POST -> {tracking_id:158184} -> Crea reserva temporal a TMS per bloquejar punts a l'user
DELETE -> param tracking_id -> Cancela la reserva a mongo i envia cancelacio a TMS*/
